import React, { useState } from 'react';
import { Input, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import updateDocument from '../../utils/document/updateDocument';
import { toast } from 'react-hot-toast';

export default function PatientDocumentEditor({ document, onSave, onCancel }) {
  const { t } = useTranslation();
  const [editedBody, setEditedBody] = useState(document.getBody());
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const updatedDocument = await updateDocument(document.getUUID(), { user_body: editedBody });
      onSave?.(updatedDocument);  // pass back the full updated document object
    } catch (error) {
      toast.error(t('patient_documents.errors.save'));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={{ marginBottom: 16, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Space style={{ marginBottom: 18 }}>
        <Button type="primary" onClick={handleSave} loading={isSaving}>
          {t('common.save')}
        </Button>
        <Button onClick={onCancel}>
          {t('common.cancel')}
        </Button>
      </Space>
      <Input.TextArea
        rows={10}
        value={editedBody}
        onChange={(e) => setEditedBody(e.target.value)}
        style={{ flex: 1, resize: 'none' }}  // take full remaining height
      />
    </div>
  );
}